// extracted by mini-css-extract-plugin
module.exports = {"ContactUsText":"ContactUsText_ContactUsText__2OGk9"};